var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 2.83341C8.45991 2.83341 8.83301 2.46032 8.83301 2.00008C8.83301 1.53984 8.45991 1.16675 7.99967 1.16675C7.53944 1.16675 7.16634 1.53984 7.16634 2.00008C7.16634 2.46032 7.53944 2.83341 7.99967 2.83341Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 2.83341C14.2932 2.83341 14.6663 2.46032 14.6663 2.00008C14.6663 1.53984 14.2932 1.16675 13.833 1.16675C13.3728 1.16675 12.9997 1.53984 12.9997 2.00008C12.9997 2.46032 13.3728 2.83341 13.833 2.83341Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16634 2.83341C2.62658 2.83341 2.99967 2.46032 2.99967 2.00008C2.99967 1.53984 2.62658 1.16675 2.16634 1.16675C1.7061 1.16675 1.33301 1.53984 1.33301 2.00008C1.33301 2.46032 1.7061 2.83341 2.16634 2.83341Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsHorizontal);
export default __webpack_public_path__ + "static/media/ThreeDotsHorizontal.4c3d101c4867b2112423af32f8c7ada5.svg";
export { ForwardRef as ReactComponent };